export function renderTipCard(text: string): HTMLElement {
  const card = document.createElement('div');
  card.className = 'card border border-emerald-100 bg-emerald-50 flex gap-3';

  const icon = document.createElement('div');
  icon.className =
    'w-10 h-10 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-xl';
  icon.textContent = '♪';

  const body = document.createElement('p');
  body.className = 'text-gray-800 leading-relaxed flex-1';
  body.textContent = text;

  card.appendChild(icon);
  card.appendChild(body);
  return card;
}
